"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/distribution/wizard");
//#region INITIAL STATE
exports.initialState = {
    isOpen: 'NONE',
    wizardStep: 0,
    step1: {
        name: '',
        description: ''
    },
    step2: {
        display: 'LIST'
    },
    id: -1,
    name: '',
    description: '',
    distributionRecipients: {},
    isSaving: 'STANDBY',
    author: null,
    errors: {},
    status: 'INITIAL',
    modified: false
};
//#endregion
//#region LENS
const isOpenLens = monocle.Lens.fromProp('isOpen');
const stepLens = monocle.Lens.fromProp('wizardStep');
const step1Lens = monocle.Lens.fromProp('step1');
const step2Lens = monocle.Lens.fromProp('step2');
const idLens = monocle.Lens.fromProp('id');
const nameLens = monocle.Lens.fromProp('name');
const authorLens = monocle.Lens.fromProp('author');
const createdAtLens = monocle.Lens.fromProp('createdAt');
const modifiedAtLens = monocle.Lens.fromProp('modifiedAt');
const modifiedLens = monocle.Lens.fromProp('modified');
const descriptionLens = monocle.Lens.fromProp('description');
const step1NameLens = monocle.Lens.fromProp('name');
const step1DescriptionLens = monocle.Lens.fromProp('description');
const errorsLens = new monocle.Optional((a) => (a.status === 'ERROR' ? fp.option.some(a.errors) : fp.option.none), (a) => (s) => (s.status === 'ERROR' ? Object.assign(Object.assign({}, s), { errors: a }) : s));
const statusLens = monocle.Lens.fromProp('status');
const distributionRecipientsLens = monocle.Lens.fromProp('distributionRecipients');
const step2DisplayLens = new monocle.Setter((display) => (state) => {
    const step2 = step2Lens.get(state);
    if (display(step2.display) === 'LIST') {
        return step2Lens.set({
            display: 'LIST'
        })(state);
    }
    else {
        return step2Lens.set({
            display: 'ADD',
            addNewDeliveryAddress: false,
            tab: 0
        })(state);
    }
});
const step2TabLens = new monocle.Setter((tab) => (state) => {
    const step2 = step2Lens.get(state);
    if (step2.display === 'ADD') {
        return step2Lens.set(Object.assign(Object.assign({}, step2), { tab: tab(step2.tab) }))(state);
    }
    else {
        return state;
    }
});
const step2AddNewDeliveryAddressLens = new monocle.Setter((f) => (state) => {
    const step2 = step2Lens.get(state);
    if (step2.display === 'ADD') {
        return step2Lens.set(Object.assign(Object.assign({}, step2), { addNewDeliveryAddress: f(step2.addNewDeliveryAddress) }))(state);
    }
    else {
        return state;
    }
});
const isSavingLens = monocle.Lens.fromProp('isSaving');
const methods = {};
exports.methods = methods;
methods[Actions.CLOSE_MENU] = (state, action) => isOpenLens.set('NONE')(state);
methods[Actions.OPEN_CREATE_MENU] = (state, action) => isOpenLens.set('CREATE')(state);
methods[Actions.OPEN_EDIT_MENU] = (state, action) => fp.function.compose(fp.function.compose(createdAtLens.set(action.payload.distribution.createdAt), modifiedAtLens.set(action.payload.distribution.modifiedAt)), fp.function.compose(authorLens.set(action.payload.distribution.author), isOpenLens.set('EDIT'), idLens.set(action.payload.distribution.id), nameLens.set(action.payload.distribution.name), descriptionLens.set(action.payload.distribution.description), step1Lens.compose(step1NameLens).set(action.payload.distribution.name), step1Lens
    .compose(step1DescriptionLens)
    .set(action.payload.distribution.description), distributionRecipientsLens.set(action.payload.distribution.recipients.reduce((r, i) => {
    const clone = Object.assign({}, r);
    clone[i.uuid] = i;
    return clone;
}, {}))))(state);
methods[Actions.VALIDATE_STEP_FAILURE] = (state, action) => {
    return fp.function.compose(errorsLens.set(action.payload.errors.reduce((rv, x) => {
        ;
        (rv[x.key] = rv[x.key] || []).push(x.value);
        return rv;
    }, {})), statusLens.set('ERROR'), isSavingLens.set('STANDBY'))(state);
};
methods[Actions.VALIDATE_STEP_SUCCESS] = (state, action) => fp.function.compose(stepLens.set(action.payload.wizardStep), statusLens.set('INITIAL'), errorsLens.set({}))(state);
//#region STEP1
methods[Actions.CHANGE_NAME] = (state, action) => {
    return fp.function.flow(step1Lens.compose(step1NameLens).set(action.payload.name), modifiedLens.set(true))(state);
};
methods[Actions.CHANGE_DESCRIPTION] = (state, action) => {
    return fp.function.flow(step1Lens.compose(step1DescriptionLens).set(action.payload.description), modifiedLens.set(true))(state);
};
//#endregion
//#region STEP2
methods[Actions.CHANGE_STEP2_DISPLAY] = (state, action) => step2DisplayLens.set(action.payload.display)(state);
methods[Actions.CHANGE_STEP2_TAB] = (state, action) => step2TabLens.set(action.payload.tab)(state);
methods[Actions.CHANGE_STEP2_ADD_NEW_DELIVERY_ADDRESS] = (state, action) => step2AddNewDeliveryAddressLens.set(action.payload.status)(state);
//#endregion
methods[Actions.ADD_DISTRIBUTION_RECIPIENT] = (state, action) => {
    return fp.function.flow(distributionRecipientsLens.modify((current) => action.payload.recipients.reduce((result, recipient) => {
        const clone = Object.assign({}, result);
        clone[recipient.uuid] = recipient;
        return clone;
    }, current)), modifiedLens.set(true))(state);
};
methods[Actions.REMOVE_DISTRIBUTION_RECIPIENT] = (state, action) => {
    return fp.function.flow(distributionRecipientsLens.modify((current) => {
        const clone = Object.assign({}, current);
        delete clone[action.payload.uuid];
        return clone;
    }), modifiedLens.set(true))(state);
};
methods[Actions.CHANGE_DISTRIBUTION_RECIPIENT_QUANTITY] = (state, action) => {
    return fp.function.flow(distributionRecipientsLens.modify((recipients) => {
        const clone = Object.assign({}, recipients);
        clone[action.payload.uuid] = Object.assign(Object.assign({}, clone[action.payload.uuid]), { quantity: action.payload.quantity });
        return clone;
    }), modifiedLens.set(true))(state);
};
methods[Actions.CHANGE_DISTRIBUTION_RECIPIENT_FINISHING] = (state, action) => {
    return fp.function.flow(distributionRecipientsLens.modify((recipients) => {
        const clone = Object.assign({}, recipients);
        clone[action.payload.uuid] = Object.assign(Object.assign({}, clone[action.payload.uuid]), { finishing: action.payload.finishing });
        return clone;
    }), modifiedLens.set(true))(state);
};
methods[Actions.CHANGE_DISTRIBUTION_RECIPIENT_DELIVERY_METHOD] = (state, action) => {
    return fp.function.flow(distributionRecipientsLens.modify((recipients) => {
        const clone = Object.assign({}, recipients);
        clone[action.payload.uuid] = Object.assign(Object.assign({}, clone[action.payload.uuid]), { deliveryMethod: action.payload.deliveryMethod });
        return clone;
    }), modifiedLens.set(true))(state);
};
methods[Actions.CHANGE_DISTRIBUTION_RECIPIENT_PRINT_PROVIDER] = (state, action) => {
    return fp.function.flow(distributionRecipientsLens.modify((recipients) => {
        const clone = Object.assign({}, recipients);
        clone[action.payload.uuid] = Object.assign(Object.assign({}, clone[action.payload.uuid]), { printProvider: action.payload.printProvider });
        return clone;
    }), modifiedLens.set(true))(state);
};
//#endregion
methods[Actions.CLEAR_WIZARD] = () => (Object.assign({}, exports.initialState));
methods[Actions.CREATE_NEW_DISTRIBUTION_REQUEST] = (state, action) => isSavingLens.set('SAVING')(state);
methods[Actions.CREATE_NEW_DISTRIBUTION_SUCCESS] = (state, action) => {
    return fp.function.flow(isSavingLens.set('SAVED'), modifiedLens.set(false))(state);
};
methods[Actions.CREATE_NEW_DISTRIBUTION_FAILED] = (state, action) => isSavingLens.set('FAILED')(state);
methods[Actions.EDIT_DISTRIBUTION_REQUEST] = (state, action) => isSavingLens.set('SAVING')(state);
methods[Actions.EDIT_DISTRIBUTION_SUCCESS] = (state, action) => {
    return fp.function.compose(isSavingLens.set('SAVED'), distributionRecipientsLens.set(action.payload.recipients.reduce((r, i) => {
        const clone = Object.assign({}, r);
        clone[i.uuid] = i;
        return clone;
    }, {})), modifiedLens.set(false))(state);
};
methods[Actions.EDIT_DISTRIBUTION_FAILED] = (state, action) => isSavingLens.set('FAILED')(state);
methods[Actions.EDIT_DISTRIBUTION_STANDBY] = (state, action) => isSavingLens.set('STANDBY')(state);
//# sourceMappingURL=wizard.js.map